import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { vuetifyColors } from '../utils/themes';
import '@fortawesome/fontawesome-pro/css/all.css';

Vue.use(Vuetify);

let themeLight = {};
let themeDark = {};
Object.keys(vuetifyColors).forEach((color) => {
  if (typeof vuetifyColors[color] !== 'string') {
    themeLight[color] = vuetifyColors[color]['light'];
    themeDark[color] = vuetifyColors[color]['dark'];
  } else {
    themeLight[color] = vuetifyColors[color];
    themeDark[color] = vuetifyColors[color];
  }
});

export default new Vuetify({
  theme: {
    dark: true /* this.$store.state.app.UiTheme */,
    themes: {
      dark: themeDark,
      light: themeLight,
    },
  },
  icons: {
    iconfont: 'fa',
    values: {
      complete: 'fal fa-check',
      cancel: 'fal fa-times',
      close: 'fal fa-times',
      delete: 'fas fa-times-circle', // delete (e.g. v-chip close)
      clear: 'fal fa-times-circle',
      success: 'fal fa-check-circle',
      info: 'fal fa-info-circle',
      warning: 'fal fa-exclamation',
      error: 'fal fa-exclamation-triangle',
      prev: 'fal fa-chevron-left',
      next: 'fal fa-chevron-right',
      checkboxOn: 'fal fa-check-square',
      checkboxOff: 'fal fa-square', // note 'far'
      checkboxIndeterminate: 'fal fa-minus-square',
      delimiter: 'fal fa-circle', // for carousel
      sort: 'fas fa-sort-up',
      expand: 'fal fa-angle-down',
      menu: 'fal fa-bars',
      subgroup: 'fal fa-angle-down',
      dropdown: 'fal fa-angle-down',
      radioOn: 'fal fa-dot-circle',
      radioOff: 'fal fa-circle',
      edit: 'fal fa-edit',
      ratingEmpty: 'fal fa-star',
      ratingFull: 'fal fa-star',
      ratingHalf: 'fal fa-star-half',
      loading: 'fal fa-sync',
      first: 'fal fa-step-backward',
      last: 'fal fa-step-forward',
      unfold: 'fal fa-arrows-alt-v',
      file: 'fal fa-paperclip',
      plus: 'fal fa-plus',
      minus: 'fal fa-minus',
      save: 'fas fa-save',
    },
  },
});
